import { useTranslation } from "react-i18next";
import FAQFr from "./FAQFR";
import FAQEn from "./FAQEN";

const FAQPage = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <div className="container mx-auto px-4 py-8 text-onWhite">
      {lang === "fr" ? <FAQFr /> : <FAQEn />}
    </div>
  );
};

export default FAQPage;
